"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegolithEaters = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const OrOptions_1 = require("../../inputs/OrOptions");
const ResourceType_1 = require("../../ResourceType");
const SelectOption_1 = require("../../inputs/SelectOption");
const CardName_1 = require("../../CardName");
const LogHelper_1 = require("../../LogHelper");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const constants_1 = require("../../constants");
const CardRenderer_1 = require("../render/CardRenderer");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Units_1 = require("../../Units");
class RegolithEaters extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.REGOLITH_EATERS,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.MICROBE],
            cost: 13,
            resourceType: ResourceType_1.ResourceType.MICROBE,
            metadata: {
                cardNumber: '033',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Add 1 Microbe to this card.', (eb) => {
                        eb.empty().startAction.microbes(1);
                    }).br;
                    b.or().br;
                    b.action('Remove 2 Microbes from this card to raise oxygen level 1 step.', (eb) => {
                        eb.microbes(2).startAction.oxygen(1);
                    }).br;
                }),
            },
        });
        this.resourceCount = 0;
    }
    play(_player) {
        return undefined;
    }
    canAct(player) {
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        const trGain = this.getTotalTRGain(player);
        if (this.resourceCount >= 2)
            Card_1.Card.setRedsActionWarningText(player, trGain, this, redsAreRuling, 'raise oxygen');
        if (redsAreRuling) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails();
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
        }
        return true;
    }
    action(player) {
        if (this.resourceCount < 2) {
            player.addResourceTo(this, { log: true });
            return undefined;
        }
        if (this.howToAffordReds !== undefined)
            player.howToAffordReds = this.howToAffordReds;
        const orOptions = new OrOptions_1.OrOptions();
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        if (!redsAreRuling || (redsAreRuling && player.canAfford(this.reserveUnits.megacredits))) {
            orOptions.options.push(new SelectOption_1.SelectOption('Remove 2 microbes to raise oxygen level 1 step', 'Remove microbes', () => {
                player.removeResourceFrom(this, 2);
                LogHelper_1.LogHelper.logRemoveResource(player, this, 2, 'raise oxygen 1 step');
                return player.game.increaseOxygenLevel(player, 1);
            }));
        }
        orOptions.options.push(new SelectOption_1.SelectOption('Add 1 microbe to this card', 'Add microbe', () => {
            player.addResourceTo(this, { log: true });
            return undefined;
        }));
        if (orOptions.options.length === 1)
            return orOptions.options[0].cb();
        return orOptions;
    }
    getActionDetails() {
        return new RedsPolicy_1.ActionDetails({ oxygenIncrease: 1 });
    }
    getTotalTRGain(player) {
        const oxygenLevel = player.game.getOxygenLevel();
        let trGain = oxygenLevel === constants_1.MAX_OXYGEN_LEVEL ? 0 : 1;
        if (oxygenLevel === 7)
            trGain += 1;
        if (player.game.getTemperature() === -2)
            trGain += 1;
        return trGain;
    }
}
exports.RegolithEaters = RegolithEaters;
//# sourceMappingURL=RegolithEaters.js.map